<template>
  <v-text-field v-bind="attributes"
                v-on="listeners"
                :value="value"
                :error="hasFieldErrors"
                @change="change"
                @focus="focused = true"
                @blur="focused = false"
                ref="proxy"/>
</template>

<script>
import InputMixin from '../mixins/input';

const DEFAULTS = {
  clearable: false,
  autocomplete: 'off',
  spellcheck: 'false',
  autocorrect: 'off',
  autocapitalize: 'off'
};

export default {
  mixins: [ InputMixin ],
  props: {
    integer: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      focused: false
    };
  },
  computed: {
    attributes () {
      let result = Object.assign({}, DEFAULTS, this.$attrs);
      this.mixinRequired(result);

      return result;
    },
    listeners () {
      return this.$listeners;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue) {
        if (!this.focused) {
          this.change(newValue);
        }
      }
    }
  },
  methods: {
    change (value) {
      let result = value;
      if (result === undefined || result === null)
      {
        result = null;
      }
      else
      {
        result = String(result);
        result = this.trimToNull(result);
        if (result !== null)
        {
          let parsed = this.$cove.parseNumber(result);
          if (parsed !== null)
          {
            result = this.integer ? this.$cove.formatNumber(parsed) : this.$cove.formatDecimal(parsed);
          }
        }
      }

      if (result !== value)
      {
        this.$emit('input', result);
        this.$emit('change', result);
      }
    },
    getValueAsNumber () {
      return this.$cove.parseNumber(this.value);
    }
  }
};
</script>